import { FLAT_RATE_PRICING_ITEM_TYPE, PER_UNIT_PRICING_ITEM_TYPE } from '@atlassian/mpac-types';
export function foldPricingItem(pricingItem) {
  return function (flatRate, perUnit) {
    switch (pricingItem.type) {
      case FLAT_RATE_PRICING_ITEM_TYPE:
        return flatRate(pricingItem);
      case PER_UNIT_PRICING_ITEM_TYPE:
        return perUnit(pricingItem);
      default:
        pricingItem;
        return undefined;
    }
  };
}